import { render } from "./Sidenav.vue?vue&type=template&id=cf486be8&scoped=true"
import script from "./Sidenav.vue?vue&type=script&lang=js"
export * from "./Sidenav.vue?vue&type=script&lang=js"

import "./Sidenav.vue?vue&type=style&index=0&id=cf486be8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf486be8"]])

export default __exports__